import { render } from "./AnimeListCards.vue?vue&type=template&id=353f8ff2&scoped=true"
import script from "./AnimeListCards.vue?vue&type=script&lang=js"
export * from "./AnimeListCards.vue?vue&type=script&lang=js"

import "./AnimeListCards.vue?vue&type=style&index=0&id=353f8ff2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-353f8ff2"]])

export default __exports__